module.exports = __webpack_public_path__ + "static/backstopper_logo-c6ac74f8b0607f5b40975e9956157734.png";